<template>
    <div>
        <div class="text-center flex flex-col items-center justify-between desktop:block text-navy">
            <div v-if="isSkeleton"
                 class="w-20 h-12
                        rounded-t-full
                        bg-gray-300
                        animate-pulse">
            </div>
            <div v-else
                 class="flex justify-center w-full pl-4 desktop:pl-0">
                <img
                    v-if="speed < 200"
                    alt=""
                    class="h-14 w-36"
                    loading="lazy"
                    src="/assets/icons/base-rabbit.svg"
                />
                <img
                    v-else-if="speed < 250"
                    alt=""
                    class="h-14 w-32 -mx-4 desktop:-mx-5"
                    loading="lazy"
                    src="/assets/icons/fast-cat.svg"
                />
                <img
                    v-else-if="speed < 1000"
                    alt=""
                    class="h-14 w-36"
                    loading="lazy"
                    src="/assets/icons/ultrafast-car.svg"
                />
                <img
                    v-else-if="speed >= 1000"
                    alt=""
                    class="h-14 w-36"
                    loading="lazy"
                    src="/assets/icons/gigafast-rocket.svg"
                />
                <img
                    v-else-if="additionalIcon"
                    alt=""
                    class="h-4 tablet:h-6 w-4 tablet:w-6 my-auto mx-2.5 desktop:mx-4"
                    loading="lazy"
                    src="/assets/icons/plus.png"
                />
                <img
                    v-if="additionalIcon"
                    alt=""
                    class="h-8 desktop:h-12 w-8 desktop:w-12 my-auto "
                    loading="lazy"
                    :src="`/assets/icons/${additionalIcon}.svg`"
                />
            </div>
            <span :class="{'text-gray-300 bg-gray-300 animate-pulse' : isSkeleton}">
                <span class="text-xl font-heavy" data-cy="product-speed" data-qa="card_product_speed">
                    {{ speed }} {{ upload? '/ ' + upload: '' }} Mbps
                </span>
                <span class="block font-bold" :class="pulsatingText">
                    Ideal for: {{ idealFor || 'Up to XX devices' }}
                </span>
            </span>
        </div>
    </div>
</template>

<script>
    import SlottedModal from '@/organisms/SlottedModal'
    import { mapState ,mapGetters, mapActions } from 'vuex'

    export default {
        name: 'InternetSpeedGauge',
        components: {
            SlottedModal,
        },
        props: {
            speed: {
                type: Number,
                required: true,
            },
            upload: {
                type: Number,
                default: null,
            },
            idealFor: {
                type: String,
                default: null,
            },
            additionalIcon: {
                type: String,
                default: null,
            },
            isSkeleton: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            pulsatingText() {
                return this.isSkeleton ? `text-gray-300
                                          bg-gray-300
                                          animate-pulse` : ''
            },
        }
    }
</script>
